import { ToolCategory } from '@bechtel/ht-types';

export const allCategoryItem: ToolCategory = {
  id: 'All',
  isActive: true,
  name: 'All Tools',
  toolHoundId: 'All',
  toolTypeId: 'All',
  toolCategoryStats: {
    consumablesCount: 0,
    toolsCount: 0,
  },
};
